// extracted by mini-css-extract-plugin
export default {"pageHeading":"PageHeading_pageHeading__Adf6w"};